module.exports = __webpack_public_path__ + "assets/img/10.7da598f0.svg";